import { isBefore, parse, setHours, setMinutes } from "date-fns";
import { groupBy } from "lodash";
import qs from "query-string";

import { IProductHistory } from "./data/entities";

export function getFilterDate(searchQuery?: string): Date {
  let date = new Date();

  if (searchQuery) {
    const { createdDate } = qs.parse(searchQuery);

    if (createdDate) {
      date = parse(createdDate.toString(), "yyyy-MM-dd", date);
    }
  }

  return setMinutes(setHours(date, 23), 59);
}

export function getProductHistoryList(productList: IProductHistory[], date: Date): IProductHistory[] {
  const grouped = groupBy(productList, "product.id");
  return Object.values(grouped)
    .map((v) => {
      const filtered = v.filter((ph) => isBefore(ph.createdDate, date));
      const sorted = filtered.sort((a, b) => {
        const isBeforeDate = isBefore(a.createdDate, b.createdDate);

        if (isBeforeDate) {
          return 1;
        } else if (!isBeforeDate) {
          return -1;
        }
        return 0;
      });
      return sorted[0];
    })
    .filter(Boolean);
}
